import Event from './Event.js';

export default class PageView extends Event {
  setData(title) {
    this._pushEventData('trackPageView', title);
  }
}
